import { Button } from "@douyinfe/semi-ui";
import React from "react";
import styles from "./Button.module.scss";

// 使用 React.ComponentProps 获取 Button 组件的 props 类型
type SemiButtonProps = React.ComponentProps<typeof Button> & {
  className?: string;
  extraclassname?: string;
};

const SemiButton = ({
  className = "",
  children = "提交",
  ...buttonProps
}: SemiButtonProps) => {
  return (
    <Button
      className={`${!!buttonProps.extraclassname ? styles[buttonProps.extraclassname] : styles.button} ${className}`}
      {...buttonProps}
    >
      {children}
    </Button>
  );
};

export default SemiButton;
